import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { Link } from 'react-router';
import type { Session } from '../../api/session';
import { NEW_UI } from '../../app/features';
import { deleteTemplate, getTemplates } from '../../api/tenant';
import { GuestType, templateLabel } from '../../domain/passes';
import { Plate, WalkerIcon } from '../../ui/Plate';
import { Skeleton } from '../../ui/Skeleton';
import c from '../pass-card/passCard.module.css';
import p from '../passes/passes.module.css';
import s from './more.module.css';

/** Saved templates: a tap orders a pass by it (the home screen's order sheet), «Удалить» removes it. */
export function GuestsScreen({ session }: { session: Session }) {
  const queryClient = useQueryClient();
  const templates = useQuery({ queryKey: ['templates'], queryFn: () => getTemplates(session) });
  const [confirmId, setConfirmId] = useState<number | null>(null);
  const remove = useMutation({
    mutationFn: (id: number) => deleteTemplate(session, id),
    onSuccess: () => {
      setConfirmId(null);
      void queryClient.invalidateQueries({ queryKey: ['templates'] });
    },
  });

  return (
    <main className={p.page}>
      <h1 className={p.title}>{NEW_UI ? 'Шаблоны' : 'Частые гости'}</h1>
      {!templates.data ? (
        <Skeleton height={120} />
      ) : templates.data.length === 0 ? (
        <p className={p.empty}>Частых гостей пока нет</p>
      ) : (
        <ul className={p.list}>
          {templates.data.map((t) => (
            <li key={t.id}>
              <div className={s.row}>
                <Link to={`/?order=template:${t.id}`} className={s.rowLink} aria-label={`Заказать по шаблону ${templateLabel(t) || t.guestData?.plateNumber || ''}`.trim()}>
                  {t.guestType !== GuestType.Pedestrian && t.guestData?.plateNumber ? <Plate value={t.guestData.plateNumber} /> : <WalkerIcon />}
                  <span className={s.rowText}>
                    {templateLabel(t) && <span className={s.rowName}>{templateLabel(t)}</span>}
                    <span className={s.rowSub}>{t.address.name}</span>
                  </span>
                </Link>
                {confirmId === t.id ? (
                  <button type="button" className={c.danger} onClick={() => remove.mutate(t.id)} disabled={remove.isPending}>
                    Да, удалить
                  </button>
                ) : (
                  <button type="button" className={s.small} aria-label={`Удалить ${templateLabel(t) || t.guestData?.plateNumber || 'шаблон'}`} onClick={() => setConfirmId(t.id)}>
                    Удалить
                  </button>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </main>
  );
}
